import { SvgIcon, SvgIconProps } from '@mui/material';

const DocumentOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="DocumentOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M8 17H16V15H8V17Z" />
      <path d="M14 13H8V11H14V13Z" />
      <path d="M8 9H11V7H8V9Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.4142 2H4V22H20V7.58579L14.4142 2ZM6 20V4H13V9H18V20H6ZM16.5858 7L15 5.41421V7H16.5858Z" />
    </SvgIcon>
  );
};

export default DocumentOutlined;
